<template>
  <div>
    <v-layout v-if="loading" justify-center align-center>
      <v-flex xs12 text-center pt-4 mt-4>
        <v-progress-circular color="accent" size="80" width="1" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>

    <v-scroll-y-transition>
      <v-layout v-show="!loading" justify-center wrap>
        <v-flex xs12 px-2 mb-2>
          <v-scale-transition>
            <v-alert
                :value="isUserDataUncompleted"
                outlined
                color="error"
                icon="new_releases"
            >
              Aún no has completado tus datos personales
            </v-alert>
          </v-scale-transition>

        </v-flex>

        <template v-if="currentProvider">

          <v-flex xs12 md6 pa-2>
            <v-sheet height="100%" >
              <v-card style="height: 100%">

                <provider-stats :provider="currentProvider" />
                <v-divider></v-divider>
                <div class="truncate-text pa-4" v-if="currentProvider.ratings_summary && currentProvider.ratings_summary.last && currentProvider.ratings_summary.last.length > 0">
                  <h1 class="caption">"{{currentProvider.ratings_summary.last[0].comment}}" - <b>{{currentProvider.ratings_summary.last[0].author.first_name || 'Anónimo'}}</b></h1>
                </div>
                <div class="truncate-text pa-4" v-else>
                  <h1 class="caption">El proveedor aun no tiene calificaciones.</h1>
                </div>
              </v-card>
            </v-sheet>

          </v-flex>

          <v-flex xs12 md6 lg6>
            <kimsa-graph
                v-if="stats && stats.activity_stats"
                title="Actividad"
                :labels="stats.activity_stats.labels"
                :values="stats.activity_stats.values"
                subtitle="Mostrando últimos 3 meses"
                additionalText="Ultima solicitud: hace 30 min."
            ></kimsa-graph>
          </v-flex>
        </template>

        <template v-else>

          <v-flex xs12 py-3>

          </v-flex>

          <v-flex xs12 md6>
            <kimsa-graph
                v-if="stats && stats.activity_stats"
                title="Actividad"
                :labels="stats.activity_stats.labels"
                :values="stats.activity_stats.values"
                subtitle="Mostrando últimos 3 meses"
                additionalText="Ultima solicitud: hace 30 min."
            ></kimsa-graph>
          </v-flex>
        </template>

        <v-flex xs12 pa-2 v-if="stats && stats.next_appointment">
          <v-parallax
              height="120"
              :src="require('@/assets/img/treatments/1.jpg')"
          >
            <v-layout align-center justify-center>
              <v-flex xs12 text-center>
                <h1 class="subtitle font-weight-thin mb-2">No olvides tu hora!</h1>
                <router-link class="subheading white--text" :to="{name: 'panel.user.appointments'}">
                  <v-icon size="18" color="white mr-1">far fa-clock</v-icon> {{`${$moment(stats.next_appointment.date).format('ddd D MMM')} | ${$moment(stats.next_appointment.time, 'H:m').format('H:mm')}`}}
                </router-link>
              </v-flex>
            </v-layout>
          </v-parallax>
        </v-flex>

        <v-flex xs12 sm3 lg2 pa-1>
          <stats-card
              v-if="stats && stats.quotations_count !== null"
              :to="{name: 'panel.user.quotation_requests'}"

              :cuenta="stats.quotations_count"
              icon="fa-calculator"
              linea2="Presupuestos solicitados"
              color="cyan"
          ></stats-card>
        </v-flex>

        <v-flex xs12 sm3 lg2 pa-1>
          <stats-card
              v-if="stats && stats.special_sales_count !== null"
              :to="{name: 'panel.user.special_sales'}"
              :cuenta="stats.special_sales_count"
              icon="fa-piggy-bank"
              linea2="Ofertas solicitadas"
              color="green"
          ></stats-card>
        </v-flex>

        <v-flex xs12 sm3 lg2 pa-1>
          <stats-card
              v-if="stats && stats.appointments_count !== null"
              :to="{name: 'panel.user.appointments'}"
              :cuenta="stats.appointments_count"
              icon="fa-calendar-day"
              linea2="Horas agendadas"
              color="pink"
          ></stats-card>
        </v-flex>

      </v-layout>
    </v-scroll-y-transition>
  </div>
</template>

<script>

import KimsaGraph from "@/components/common/KimsaGraph";
import StatsCard from "@/components/common/panel/StatsCard";
import ProviderStats from "@/components/providers/ProviderStats";
import {ApiUtils} from "@/utils/ApiUtils";
import {mapState} from "vuex";

export default {
name: "BasicProviderDashboard",
  components:{
    KimsaGraph,
    StatsCard,
    ProviderStats,
  },

  data() {
    return {
      loading: true,
      error: false,
      stats: null,
    }
  },

  mounted() {
    this.getStats()
  },

  methods: {

    async getStats(){

      var vm = this
      vm.loading = true
      const response = await ApiUtils.makeGet('user/stats')

      setTimeout(function(){
        vm.loading = false
      }, 1000)

      if (!response.ok) {
        vm.error = true
        return
      }

      const json = await response.json()
      vm.stats = json.result.stats

    }
  },
  computed: {
    ...mapState(['currentUser', 'currentProvider']),
    isUserDataUncompleted(){
      var vm = this
      return !vm.currentUser ||
          !vm.currentUser.first_name ||
          !vm.currentUser.last_name ||
          !vm.currentUser.email ||
          !vm.currentUser.dni ||
          vm.currentUser.insurance_company === null ||
          !vm.currentUser.phone1
    }
  },
  watch:{
    currentProvider(){
      const vm = this
      vm.getStats()
    }
  }
}
</script>

<style scoped>

</style>
